import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Service$SolvuuApi0 from "./service.bs.js";
import * as Job_metrics_atd$SolvuuApi0 from "./job_metrics_atd.bs.js";
import * as Job_metrics_get_by_id_request_atd$SolvuuApi0 from "./job_metrics_get_by_id_request_atd.bs.js";
var entity = "jobs-metrics";
var service = Service$SolvuuApi0.Get_by_id.service(entity);

var path = Curry._1(Service$SolvuuApi0.Get_by_id.$$Request.path, entity);

var body = Service$SolvuuApi0.Get_by_id.$$Request.body;

var info = Curry._1(Service$SolvuuApi0.Get_by_id.$$Request.info, entity);

var $$Request = {
  Json: Job_metrics_get_by_id_request_atd$SolvuuApi0.Json,
  json_of_info: Job_metrics_get_by_id_request_atd$SolvuuApi0.json_of_info,
  info_of_json: Job_metrics_get_by_id_request_atd$SolvuuApi0.info_of_json,
  path: path,
  body: body,
  info: info
};
var Get_by_id = {
  service: service,
  entity: entity,
  $$Request: $$Request,
  $$Response:
  /* alias */
  0
};
var Json = Job_metrics_atd$SolvuuApi0.Json;
var json_of_point = Job_metrics_atd$SolvuuApi0.json_of_point;
var json_of_t = Job_metrics_atd$SolvuuApi0.json_of_t;
var point_of_json = Job_metrics_atd$SolvuuApi0.point_of_json;
var t_of_json = Job_metrics_atd$SolvuuApi0.t_of_json;
export { Json, json_of_point, json_of_t, point_of_json, t_of_json, entity, Get_by_id };
/* service Not a pure module */